import connectAssetSubscriptions from './Asset/connectAssetSubscriptions';
import connectPlaybackSubscriptions from './Playback/connectPlaybackSubscriptions';
import connectConfigSubscriptions from './Config/connectConfigSubscriptions';
import connectConcurrencySubscriptions from './Concurrency/connectConcurrencySubscriptions';
import connectPrecisionSubscriptions from './Precision/connectPrecisionSubscriptions';
import connectResumePointsSubscriptions from './ResumePoints/connectResumePointsSubscriptions';

const connectStoreSubscriptions = middleware => [
    ...connectAssetSubscriptions(middleware),
    ...connectConcurrencySubscriptions(middleware),
    ...connectConfigSubscriptions(middleware),
    ...connectPlaybackSubscriptions(middleware),
    ...connectPrecisionSubscriptions(middleware),
    ...connectResumePointsSubscriptions(middleware),
];

export default connectStoreSubscriptions;
